import * as XLSX from "xlsx";

const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  const cleaned = String(value).replace(/,/g, "").replace(/AED/gi, "").trim();
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
};

const normalizeKey = (key) =>
  String(key || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const cleanRow = (row) => {
  const out = {};
  Object.entries(row || {}).forEach(([key, value]) => {
    out[normalizeKey(key)] = value;
  });
  return out;
};

const driverKey = (name = "") =>
  String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter((word) => !["mr", "mrs", "ms", "driver", "chauffeur", "sir"].includes(word))
    .slice(0, 3)
    .join(" ");

const iso = (year, month, day) => {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  if (!y || !m || !d) return "";
  const dt = new Date(y, m - 1, d);
  if (Number.isNaN(dt.getTime()) || dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return "";
  return `${String(y).padStart(4, "0")}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
};

export function normalizePortalDate(value) {
  if (!value && value !== 0) return "";

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return iso(value.getFullYear(), value.getMonth() + 1, value.getDate());
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    const parsed = XLSX.SSF.parse_date_code(value);
    if (parsed) return iso(parsed.y, parsed.m, parsed.d);
  }

  const text = String(value).trim();
  if (!text) return "";

  let m = text.match(/^(20\d{2})[-/.](\d{1,2})[-/.](\d{1,2})$/);
  if (m) return iso(m[1], m[2], m[3]);

  m = text.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](20\d{2})$/);
  if (m) return iso(m[3], m[2], m[1]);

  const parsed = new Date(text);
  if (!Number.isNaN(parsed.getTime())) {
    return iso(parsed.getFullYear(), parsed.getMonth() + 1, parsed.getDate());
  }

  return "";
}

export async function readDailyBookingPortalFile(file) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, { type: "array", cellDates: true });
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  return XLSX.utils.sheet_to_json(sheet, { defval: "", raw: true });
}

export function normalizeDailyBookingPortalRows(rows = []) {
  const normalized = [];
  const invalidRows = [];

  rows.forEach((raw, index) => {
    const r = cleanRow(raw);
    const date = normalizePortalDate(
      r.date || r.trip_date || r.booking_date || r.report_date
    );
    const name = String(
      r.driver_name || r.driver || r.chauffeur || r.chauffeur_name || ""
    ).replace(/\s+/g, " ").trim();
    const bankIncome = toNumber(
      r.bank_income ?? r.bank ?? r.bank_amount ?? r.online_income ?? r.card_income
    );
    const cashIncome = toNumber(
      r.cash_income ?? r.cash ?? r.cash_amount ?? r.cash_collected
    );

    if (!date || !name) {
      invalidRows.push({ rowNumber: index + 2, date: date || "", name, raw });
      return;
    }

    const key = driverKey(name);
    if (!key) {
      invalidRows.push({ rowNumber: index + 2, date, name, raw });
      return;
    }

    normalized.push({
      raw,
      reportDate: date,
      platform: "booking_portal",
      driver_id: key,
      name,
      bank_income: bankIncome,
      cash_income: cashIncome,
    });
  });

  return { rows: normalized, invalidRows };
}
